import React from 'react'
import { StyledSpinner, StyledSpinnerWrapper as S } from './Spinner.styles'

type TProps = {
  isAbsoluteCentering?: boolean
}

export const Spinner: React.FC<TProps> = ({ isAbsoluteCentering = false }) => (
  <S.Wrapper>
    <StyledSpinner isAbsoluteCentering={isAbsoluteCentering} />
  </S.Wrapper>
)
